module.exports = __webpack_public_path__ + "img/8.2462b6f4.webp";